export const BUILDER = 'builder';
export const CART = 'cart';
export let EntityType = /*#__PURE__*/function (EntityType) {
  EntityType["order"] = "order";
  EntityType["product"] = "Product";
  EntityType["box"] = "Box";
  EntityType["boxItem"] = "Box item";
  return EntityType;
}({});
export const boxTransferWarning = 'Box size could have changed';
export let SPLIT_SHIPPED_ITEM_TYPE = /*#__PURE__*/function (SPLIT_SHIPPED_ITEM_TYPE) {
  SPLIT_SHIPPED_ITEM_TYPE["toInventory"] = "toInventory";
  SPLIT_SHIPPED_ITEM_TYPE["toCustomer"] = "toCustomer";
  return SPLIT_SHIPPED_ITEM_TYPE;
}({});